import { withRouter } from 'react-router';
import styles from './TitMod.module.less'

function Index({ title, modClass = '', children }) {   
  return (
    <div className={`mod ${styles.titMod} ${modClass}`}>
      <h3 className={styles.tit}>{ title }</h3>
      { children }
    </div>
  );
}

export default withRouter(Index);
